
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-16/tables/ixtal",
      function () {
        return require("private-next-pages/info/set-16/tables/ixtal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-16/tables/ixtal"])
      });
    }
  